import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faClock, faMapMarkerAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface ServiceNotificationProps {
  clienteNombre: string;
  tipoServicio: string;
  fecha: string;
  domicilio: string;
}

/**
 * Componente de notificación personalizada para servicios programados
 */
const ServiceNotification: React.FC<ServiceNotificationProps> = ({
  clienteNombre,
  tipoServicio,
  fecha,
  domicilio
}) => {
  const formatTime = (dateString: string) => {
    return new Date(dateString).toLocaleString('es-MX', { 
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div 
      style={{ 
        padding: '12px',
        borderRadius: '8px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6'
      }}
    >
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: '10px',
        color: '#495057',
        fontWeight: 'bold'
      }}>
        <FontAwesomeIcon 
          icon={faBell as IconProp} 
          style={{ marginRight: '8px', color: '#007bff' }} 
        />
        Servicio Programado en 15 minutos
      </div>

      {/* Content */}
      <div style={{ fontSize: '14px', lineHeight: '1.5', color: '#6c757d' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
          <FontAwesomeIcon 
            icon={faUser as IconProp} 
            style={{ marginRight: '8px', width: '14px', color: '#28a745' }} 
          />
          <strong>Tecnico:</strong> 
          <span style={{ marginLeft: '6px' }}>{clienteNombre}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
          <FontAwesomeIcon 
            icon={faClock as IconProp} 
            style={{ marginRight: '8px', width: '14px', color: '#ffc107' }} 
          />
          <strong>Servicio:</strong> 
          <span style={{ marginLeft: '6px' }}>{tipoServicio}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
          <FontAwesomeIcon 
            icon={faClock as IconProp} 
            style={{ marginRight: '8px', width: '14px', color: '#dc3545' }} 
          />
          <strong>Fecha y Hora:</strong> 
          <span style={{ marginLeft: '6px' }}>{formatTime(fecha)}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <FontAwesomeIcon 
            icon={faMapMarkerAlt as IconProp} 
            style={{ marginRight: '8px', width: '14px', color: '#6f42c1', marginTop: '2px' }} 
          />
          <div>
            <strong>Dirección:</strong>
            <div style={{ marginLeft: '0px', marginTop: '2px', fontSize: '13px' }}>
              {domicilio}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceNotification;
